import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import DeleteIcon from '@mui/icons-material/Delete';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import CustomTable from '../../../components/customTable';
import getEnvironement from '../../../../environnement';
import CustomBackdrop from '../../../../components/backdrop';
import CustomSelect from '../../../../components/customSelect';
import ResumeDialog from './components/resumeDialog';
import DeleteDialog from './components/deleteDialog';
import StatutDialog from './components/statutDialog';

export default function Soumission() {
  const [chercherTypeSoumission, setChercherTypeSoumission] = useState('');
  const [soumissions, setSoumissions] = useState([]);
  const [filtredSoumissions, setFiltredSoumissions] = useState(soumissions);
  const [selectedSoumission, setSelectedSoumission] = useState();
  const [openResumeDialog, setOpenResumeDialog] = useState(false);
  const [openStatutDialog, setOpenStatutDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [isLoader, setIsLoader] = useState(true);
  const [openBackdrop, setOpenBackdrop] = useState(false);

  function getStatut(statut) {
    if (statut === 'Non payé') {
      return (<span className='bg-primary text-white px-5 mx-5 rounded-full inline-block whitespace-nowrap'>Non payé</span>);
    } else {
      return 'Payé';
    }
  }

  const getSoumissions = useCallback(async () => {
    setIsLoader(true);
    const url = `${getEnvironement().API_URL}/getAllSoumissions`;
    await axios.post(url)
      .then((res) => setSoumissions(res.data.soumissions))
      .then(() => setIsLoader(false))
      .catch(() => setIsLoader(false));
  }, []);

  useEffect(() => {
    setFiltredSoumissions(soumissions);
  }, [soumissions]);

  useEffect(() => {
    getSoumissions();
  }, [getSoumissions]);

  return (
    <div className='flex flex-col h-full'>
      <CustomBackdrop open={openBackdrop} setOpen={setOpenBackdrop} />
      <StatutDialog
        open={openStatutDialog}
        handleClose={() => setOpenStatutDialog(false)}
        reloadData={getSoumissions}
        soumission={selectedSoumission}
      />
      <DeleteDialog
        open={openDeleteDialog}
        handleClose={() => setOpenDeleteDialog(false)}
        reloadData={getSoumissions}
        soumission={selectedSoumission}
      />
      <ResumeDialog
        open={openResumeDialog}
        handleClose={() => setOpenResumeDialog(false)}
        soumission={selectedSoumission}
      />
      <CustomSelect
        items={[
          {id: 0, value: '', label: 'Toutes les soumissions'},
          {id: 1, value: 'CO', label: 'Communication orale'},
          {id: 2, value: 'CA', label: 'Communication affichée'},
          {id: 3, value: 'Scénario', label: 'Scénario'},
          {id: 4, value: 'Spéctateur', label: 'Spéctateur'},
        ]}
        placeholder='Chercher par type de soumission'
        value={chercherTypeSoumission}
        setValue={(content) => {
          if (content === '') {
            setFiltredSoumissions(soumissions);
          } else {
            if (chercherTypeSoumission === 'Spéctateur') {
              setFiltredSoumissions(soumissions.filter(soumission => soumission.typeInscription === 'Spéctateur'));
            } else {
              setFiltredSoumissions(soumissions.filter(soumission => soumission.typeSoumission === content));
            }
          }
          setChercherTypeSoumission(content)}}
        isError
      />
      <div className='flex-grow h-[48vh]'>
        <CustomTable
          headers={[
            `ID (${filtredSoumissions.length})`,
            'Titre',
            'Auteur',
            'Co-auteur',
            'Continent',
            'Catégorie',
            'Pays',
            'Ville',
            'Spécialité',
            'Type de participation',
            'Type de soumission',
            'Résumé',
            'Tél',
            'E-mail',
            'Statut',
            'Actions'
          ]}
          config
        >
          <tbody>
            {
              filtredSoumissions.map((item, index) => {
                return (
                  <tr key={index} className='border-b-2 border-gray'>
                    <td className='text-center font-medium text-xl py-2'>{item.id}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.titre}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.auteur}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.coAuteur}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.nationalite}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.profession}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.pays}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.ville}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.specialite}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.typeParticipation}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.typeSoumission}</td>
                    <td className='text-center font-medium text-xl py-2'>
                      <Tooltip title="Afficher le contenu du résumé">
                        <IconButton onClick={() => {
                          setSelectedSoumission(item);
                          setOpenResumeDialog(true);
                        }}
                        >
                          <VisibilityIcon sx={{color: 'black'}}/>
                        </IconButton>
                      </Tooltip>
                    </td>
                    <td className='text-center font-medium text-xl py-2'>{item.tel}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.email}</td>
                    <td className='text-center font-medium text-xl py-2'>{getStatut(item.isPayement === 1 ? 'Payé' : 'Non payé')}</td>
                    <td className='text-center font-medium text-xl py-2'>
                      <div className='flex justify-center items-center'>
                        {/* <Tooltip title="Modifier le matériel">
                          <IconButton onClick={() => {
                            setSelectedSoumission(item);
                            // setOpenSoumissionDialog(true);
                          }}
                          >
                            <EditIcon sx={{color: 'black'}}/>
                          </IconButton>
                        </Tooltip> */}
                        <Tooltip title='Modifier le statut'>
                          <IconButton onClick={() => {
                            setSelectedSoumission(item);
                            setOpenStatutDialog(true);
                          }}
                          >
                            <ModeEditIcon sx={{color: 'black'}}/>
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Supprimer la soumission">
                          <IconButton onClick={() => {
                            setSelectedSoumission(item);
                            setOpenDeleteDialog(true);
                          }}
                          >
                            <DeleteIcon sx={{color: 'black'}}/>
                          </IconButton>
                        </Tooltip>
                      </div>
                    </td>
                  </tr>
                );
              })
            }
            {filtredSoumissions.length === 0 && (
              <div className='border-dashed border-4 border-primary rounded-[30px] p-5 hidden xl:inline-block fixed mx-10 my-8 w-[65vw] md:w-[80vw] lg:w-[85vw] 3xl:w-[1100px]'>
                <p className='font-inter text-primary font-bold text-xl text-center'>
                  {isLoader ? (<CircularProgress open={isLoader} sx={{color: '#A31732'}}/>) : 'Aucune soumission'}
                </p>
              </div>
            )}
          </tbody>
        </CustomTable>
      </div>
    </div>
  );
}
